export const SRP_LISTING_LIMIT = 40

export const DEVICE_TYPE = {
  MOBILE: 'MWEB',
  DESKTOP: 'DESKTOP',
} as const

export const LEGACY_HP_LG_BREAKPOINT = 1148
export const LEGACY_VIP_LG_BREAKPOINT = 1330
export const LEGACY_VIP_MD_BREAKPOINT = 980
